import axios from 'axios';

const HOST_URL = typeof window !== 'undefined' ? `${window.location.origin}/sponsored/v1` : null;

const get = async (config = null) => {
  return axios.get(HOST_URL, config);
};

export { get };
